import { useState } from "react";
import { Col, Row } from "reactstrap";
import Search from "../../../../../components/common/Search/Search";
import { GrDesktop } from "react-icons/gr";
import { CiMobile1 } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import WhiteButton from "../../../../../components/WholesalerComponents/Settings/WhiteButton/WhiteButton";
import PageCard from "../../../../../components/WholesalerComponents/Settings/StoreSetting/PageCard";
import ViewToggleTabs from "../../../../../components/WholesalerComponents/Settings/ViewToggleTabs/ViewToggleTabs";
import DesktopVersionView from "../../../../../components/WholesalerComponents/Settings/StoreSetting/DesktopVersionView/DesktopVersionView";

const StoreThemes = () => {
  const navigate = useNavigate();

  const tabs = [
    { id: "desktop", label: "Desktop Version", icon: <GrDesktop /> },
    { id: "mobile", label: "Mobile Version", icon: <CiMobile1 /> },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const pageCardData = [
    {
      id: 1,
      title: "Homepage",
      createdOn: "13/07/2024",
      modifiedOn: "13/07/2024",
      status: "Online",
      bordered: true,
    },
    {
      id: 2,
      title: "About Us",
      createdOn: "10/07/2024",
      modifiedOn: "12/07/2024",
      status: "Offline",
      bordered: false,
    },
    {
      id: 3,
      title: "Contact",
      createdOn: "05/07/2024",
      modifiedOn: "11/07/2024",
      status: "Online",
      bordered: false,
    },
  ];

  return (
    <Row className="g-0 mt-3 row-gap-4">
      <Col xxl={6} className="pe-xxl-3">
        <div
          className="bg-white d-flex align-items-center justify-content-between"
          style={{ borderBlock: "4px solid #FBBD34", padding: ".4rem" }}
        >
          <div className="fs-5 fw-semibold">Store Page Themes</div>
          <div className="d-flex gap-2">
            <WhiteButton
              onClick={() => navigate("/settings/create-store-page")}
            >
              Create New
            </WhiteButton>
            <Search />
          </div>
        </div>
        <div className="p-2 bg-white shadow">
          {pageCardData.map((page) => (
            <PageCard
              key={page.id}
              title={page.title}
              createdOn={page.createdOn}
              modifiedOn={page.modifiedOn}
              status={page.status}
              bordered={page.bordered}
            />
          ))}
        </div>
      </Col>
      <Col xxl={6} className="ps-xxl-3">
        <div className="bg-white px-2 py-1 mb-2">
          <ViewToggleTabs
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>

        {/* {activeTab === tabs[0].id && <DesktopVersionView url="http://localhost:3000/brand-store" />} */}
        <DesktopVersionView url="http://localhost:3000/brand-store" />
      </Col>
    </Row>
  );
};

export default StoreThemes;